// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'

/** Spec 20261028-132500: the kinds of the first cut; the screen words each one. */
export const NOTIFICATION_KIND_VALUES = [
    'acrescimo_em_revisao',
    'acrescimo_aprovado',
    'acrescimo_recusado',
    'material_pendente',
    'retirada_recebida',
    'ocorrencia_aberta',
    'ocorrencia_respondida',
] as const

/**
 * One notice (AC-1, AC-2): the kind and the record it points to, and when it was made and read. No name, CPF, phone
 * or text about a patient. Strict, so a field that starts leaking fails here.
 */
export const notificationSchema = z
    .object({
        id: z.number().int().positive(),
        kind: z.enum(NOTIFICATION_KIND_VALUES),
        subjectType: z.enum(['acrescimo', 'retirada', 'ocorrencia']),
        subjectId: z.string(),
        hospitalId: z.number().int().nullable(),
        createdAt: z.string(),
        readAt: z.string().nullable(),
    })
    .strict()
export type Notification = z.infer<typeof notificationSchema>

/** GET /api/notifications: the latest notices, newest first, and how many are unread. */
export const notificationListSchema = z
    .object({
        items: z.array(notificationSchema),
        unread: z.number().int().nonnegative(),
    })
    .strict()
export type NotificationList = z.infer<typeof notificationListSchema>
